import { useMemo } from 'react';
import { type VehicleCycledEnergyRecord } from '../services/battery-monitoring-api/types/battery-monitoring-api';

interface UseSelectedVehicleProperties {
  vehicles?: VehicleCycledEnergyRecord[];
  selectedChassisNumber: string | null;
}

const useSelectedVehicle = ({
  vehicles,
  selectedChassisNumber,
}: UseSelectedVehicleProperties): VehicleCycledEnergyRecord | undefined =>
  useMemo(
    () => vehicles?.find((vehicle) => vehicle.chassisNumber === selectedChassisNumber),
    [vehicles, selectedChassisNumber],
  );

export default useSelectedVehicle;
